import {stringValue} from 'vega-util';

export default function(obj, key, value) {
  return obj + '[' + stringValue(key) + ']=' + value + ';';
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/encode/set.js
// module id = 824
// module chunks = 0